var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "organisation",
      attrs: { title: _vm.currentUser.organisationName }
    },
    [
      _vm.isTestOrganisation
        ? _c(
            "span",
            [
              _c("router-link", { attrs: { to: "/reset" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("truncate")(
                        _vm._f("toUpperCase")(_vm.currentUser.organisationName),
                        _vm.maxLen
                      )
                    ) +
                    "\n    "
                )
              ])
            ],
            1
          )
        : _c("span", [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm._f("truncate")(
                    _vm._f("toUpperCase")(_vm.currentUser.organisationName),
                    _vm.maxLen
                  )
                ) +
                "\n  "
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }